module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-book"
    }
  }, [_c('h1', [_vm._v("About the Book")]), _vm._v(" "), _c('p', [_vm._v("After a sunset concert at the pavilion, they walked home by the harbor. Finn asked her to sit for a while with him, and then he declared himself. He took her hand and said, “Molly, my beautiful one, I have loved you from the time I moved into your family’s house. I can’t hold back any longer, and I am asking if you would consider being my wife.”")]), _vm._v(" "), _c('p', [_vm._v("Her eyes widened with surprise, and then she said, \"I love you more than anything, and I want to be with you forever.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72eaecfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0